<template>
  <v-card>
    <v-list dense>
      <v-list-item @click="$emit('open-in-stayin')">
        <v-list-item-title>
          <v-icon left small>mdi-open-in-new</v-icon>
          {{ trans('general.openInStayin') }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';

export default {
  name: 'OpenInStayinMenu',
  mixins: [
    LocaleUtils
  ]
}
</script>
